var React = require('react');

function Demo (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-2 {\n        fill: #fff;\n      }\n    ")),React.createElement("g",{"id":"Group_390","data-name":"Group 390","key":1},React.createElement("path",{"id":"Path_591","data-name":"Path 591","className":"cls-2","d":"M2,26.924H53.848V50.256a2.592,2.592,0,0,1-2.592,2.592H4.592A2.592,2.592,0,0,1,2,50.256ZM40.886,6.185h10.37a2.592,2.592,0,0,1,2.592,2.592V21.739H2V8.777A2.592,2.592,0,0,1,4.592,6.185h10.37V1h5.185V6.185H35.7V1h5.185Z","transform":"translate(3.185 1.592)"}))]);
}

Demo.defaultProps = {"id":"calendar-fill","width":"62.218","height":"62.218","viewBox":"0 0 62.218 62.218"};

module.exports = Demo;

Demo.default = Demo;
